var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTanzania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4541C24.8366 32.4541 32 25.2907 32 16.4541C32 7.61755 24.8366 0.454102 16 0.454102C7.16344 0.454102 0 7.61755 0 16.4541C0 25.2907 7.16344 32.4541 16 32.4541Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68579 27.7675C5.35697 28.4387 6.0731 29.0373 6.82429 29.5643L29.1099 7.27856C28.583 6.52738 27.9844 5.81125 27.3132 5.14006C26.642 4.46888 25.9259 3.87038 25.1747 3.34338L2.88916 25.6291C3.41604 26.3801 4.01466 27.0962 4.68579 27.7675V27.7675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68636 5.1407C-0.361261 10.1884 -1.33032 17.7691 1.77736 23.7906L23.3362 2.23176C17.3148 -0.875926 9.73405 0.0931983 4.68636 5.1407V5.1407Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3136 27.7678C32.3613 22.7202 33.3303 15.1393 30.2227 9.1179L8.66382 30.6768C14.6851 33.7845 22.2659 32.8154 27.3136 27.7678Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTanzania);
export default __webpack_public_path__ + "static/media/tanzania.568c7c4e.svg";
export { ForwardRef as ReactComponent };